import { t } from '@/plugins/i18n'
import { getCustomerShopPlatform, isD2C } from '@/store'

export const d2cOrderColumns: any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 250,
    slotName: 'platformOrderNo'
  },
  {
    label: t('收件人姓名'),
    prop: 'receiveName',
    align: 'center'
  },
  {
    label: t('客户订单编号'),
    prop: 'customerOrderNo',
    align: 'center',
    width: 160,
    slotName: 'customerOrderNo'
  },
  {
    label: t('订单') + `(${getCustomerShopPlatform()})`,
    prop: 'orderName',
    align: 'center',
    width: 160,
    slotName: 'orderName'
  },
  {
    label: t('订单来源'),
    prop: 'orderSource',
    align: 'center',
    slotName: 'orderSource'
  },
  {
    label: t('订单类型'),
    prop: 'platformOrderType',
    align: 'center',
    slotName: 'platformOrderType',
    width: 160
  },
  {
    label: t('发货附加项'),
    prop: 'platformOrderDeliveryAdditionalList',
    width: 160,
    align: 'center',
    slotName: 'platformOrderDeliveryAdditionalList'
  },
  {
    label: t('下单时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  },
  {
    label: t('国际物流信息详情'),
    prop: 'inShippingInfo',
    slotName: 'inShippingInfo',
    align: 'center',
    width: 200
  },
  {
    label: t('订单是否结算'),
    prop: 'platformOrderSettleStatus',
    slotName: 'platformOrderSettleStatus',
    slotHeadName: 'platformOrderSettleStatusHead',
    align: 'center',
    width: 120
  },
  {
    label: t('发货仓库'),
    prop: 'wareCode',
    slotName: 'wareCode',
    align: 'center',
    width: 200
  },
  {
    label: t('是否有异常联络'),
    prop: 'abnormalSlot',
    slotName: 'abnormalSlot',
    align: 'center',
    width: 200
  },
  {
    label: t('支付信息'),
    prop: 'stageInfos',
    slotName: 'payInfoSlot',
    align: 'center',
    width: 380
  }
]

export const b2bOrderColumns: any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    width: 240,
    slotName: 'platformOrderNo'
  },
  {
    label: t('订单标题'),
    prop: 'customerOrderNo',
    align: 'center',
    width: 140,
    slotName: 'customerOrderNo'
  },
  {
    label: t('下单时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  },
  {
    label: t('订单是否结算'),
    prop: 'platformOrderSettleStatus',
    slotName: 'platformOrderSettleStatus',
    slotHeadName: 'platformOrderSettleStatusHead',
    align: 'center'
  },
  // 韩国仓todo
  {
    label: t('采购国家'),
    prop: 'deliveryCountry',
    slotName: 'deliveryCountry',
    align: 'center',
    width: 200,
    isMultiStore: true
  },
  {
    label: t('是否有异常联络'),
    prop: 'abnormalSlot',
    slotName: 'abnormalSlot',
    align: 'center',
    width: 200
  },
  {
    label: t('支付信息'),
    prop: 'stageInfos',
    slotName: 'payInfoSlot',
    align: 'center',
    width: 380
  },
  {
    label: t('国际物流信息详情'),
    prop: 'inShippingInfo',
    slotName: 'inShippingInfo',
    align: 'center',
    width: 200
  }
]

export const d2cOrderTabs = [
  {
    title: t('所有订单'),
    name: 'all'
  },
  {
    title: t('待付款'),
    name: '2'
  },
  {
    title: t('处理中'),
    name: '4'
  },
  {
    title: t('可发货'),
    name: '8'
  },
  {
    title: t('部分发货'),
    name: '16'
  },
  {
    title: t('已完成'),
    name: '32'
  }
]

export const b2bOrderTabs = [
  {
    title: t('所有订单'),
    name: 'all'
  },
  {
    title: t('待付款'),
    name: '2'
  },
  {
    title: t('处理中'),
    name: '4'
  },
  {
    title: t('已完成'),
    name: '32'
  }
]
export const b2bChildColumns: any = [
  {
    label: t('商品信息'),
    width: 180,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    width: 160,
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    width: 120,
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    width: 160,
    align: 'center',
    slotName: 'productSku'
  },
  // 韩国仓todo
  {
    label: t('商品所属国家'),
    prop: 'goodsCountry',
    slotName: 'goodsCountry',
    align: 'center',
    width: 200,
    isMultiStore: true
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats',
    width: 140
  },
  {
    label: t('结算状态'),
    align: 'center',
    prop: 'settleStatus',
    slotName: 'settleStatus',
    width: 140
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionDTOList',
    width: 160,
    align: 'center',
    slotName: 'platformOrderItemAdditionDTOList'
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    slotName: 'actualProductSellPrice',
    align: 'center',
    width: 160
  },
  {
    label: `${t('总价')}`,
    prop: 'actualTotalProductSellPrice',
    slotName: 'actualTotalProductSellPrice',
    align: 'center',
    width: 160
  },
  {
    label: `${t('采购均价')}`,
    prop: 'averagePrice',
    align: 'center',
    slotName: 'averagePrice',
    width: 180
  },
  {
    label: t('最终采购价'),
    prop: 'final',
    align: 'center',
    slotName: 'final',
    slotHeadName: 'finalHead',
    width: 180
  },
  {
    label: t('业务类型'),
    prop: 'channel',
    align: 'center',
    slotName: 'channel',
    width: 130
  },
  {
    label: t('是否有异常联络'),
    prop: 'abnormalSlot',
    align: 'center',
    slotName: 'abnormalSlot',
    width: 130
  },
  {
    label: t('详情费用'),
    prop: 'feeInfo',
    align: 'center',
    slotName: 'feeInfo'
  }
  // {
  //   label: t('代买手续费') + '/' + t('档口手续费'),
  //   prop: 'purchasingFee',
  //   align: 'center',
  //   slotName: 'purchasingFee'
  // },
  // {
  //   label: t('国内运费'),
  //   prop: 'domesticShipping',
  //   align: 'center'
  // },
  // {
  //   label: t('入库手续费'),
  //   prop: 'storageFee',
  //   align: 'center'
  // },
  // {
  //   label: t('出库手续费'),
  //   prop: 'deliverStorageFee',
  //   align: 'center'
  // }
]

export const d2cChildColumns: any = [
  {
    label: t('商品信息'),
    width: 180,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    width: 160,
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    width: 120,
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    width: 160,
    align: 'center',
    slotName: 'productSku'
  },
  // 韩国仓todo
  {
    label: t('商品采购国家'),
    prop: 'purchaseCountry',
    slotName: 'purchaseCountry',
    align: 'center',
    width: 200,
    isMultiStore: true
  },
  {
    label: t('建议补货数量'),
    prop: 'quantity',
    align: 'center',
    slotName: 'quantity',
    width: 140,
    show: [7]
  },
  {
    label: t('历史需补货数'),
    prop: 'historyReplenishQuantity',
    align: 'center',
    show: [7]
  },
  {
    label: t('被取消需补货数'),
    prop: 'cancelReplenishQuantity',
    align: 'center',
    show: [7]
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center',
    hidden: [7]
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats',
    width: 200
  },
  {
    label: t('结算状态'),
    align: 'center',
    prop: 'settleStatus',
    slotName: 'settleStatus',
    width: 140
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionDTOList',
    width: 160,
    align: 'center',
    slotName: 'platformOrderItemAdditionDTOList'
  },
  {
    label: `${t('商品单价')}`,
    prop: 'actualProductSellPrice',
    slotName: 'actualProductSellPrice',
    align: 'center',
    width: 160
  },
  {
    label: `${t('总价')}`,
    prop: 'actualTotalProductSellPrice',
    slotName: 'actualTotalProductSellPrice',
    align: 'center',
    width: 160
  },
  {
    label: `${t('采购均价')}`,
    prop: 'averagePrice',
    align: 'center',
    slotName: 'averagePrice',
    width: 180
  },
  {
    label: t('最终采购价'),
    prop: 'final',
    align: 'center',
    slotName: 'final',
    slotHeadName: 'finalHead',
    width: 180
  },
  {
    label: t('业务类型'),
    prop: 'channel',
    align: 'center',
    slotName: 'channel',
    width: 130
  },
  {
    label: t('是否有异常联络'),
    prop: 'abnormalSlot',
    align: 'center',
    slotName: 'abnormalSlot',
    width: 130
  },
  {
    label: t('发货取消结果'),
    prop: 'cancelProgress',
    align: 'center',
    slotName: 'cancelProgress'
  }, {
    label: t('操作'),
    prop: 'operate',
    align: 'center',
    slotName: 'operate',
    width: 150
  }
  // {
  //   label: t('代买手续费') + '/' + t('档口手续费'),
  //   prop: 'purchasingFee',
  //   align: 'center',
  //   slotName: 'purchasingFee'
  // },
  // {
  //   label: t('国内运费'),
  //   prop: 'domesticShipping',
  //   align: 'center'
  // },
  // {
  //   label: t('入库手续费'),
  //   prop: 'storageFee',
  //   align: 'center'
  // },
  // {
  //   label: t('出库手续费'),
  //   prop: 'deliverStorageFee',
  //   align: 'center'
  // }
]

export const d2cChoiceChildColumns: any = [
  {
    label: t('商品信息'),
    width: 180,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    width: 160,
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    width: 120,
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    width: 160,
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionDTOList',
    width: 160,
    align: 'center',
    slotName: 'platformOrderItemAdditionDTOList'
  },
  {
    label: t('结算状态'),
    align: 'center',
    prop: 'settleStatus',
    slotName: 'settleStatus',
    width: 140
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats',
    width: 200
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('实际清算数量'),
    prop: 'settlementQuantity',
    align: 'center'
  },
  {
    label: t('全包单价'),
    prop: 'allIncludeProductPrice',
    slotName: 'allIncludeProductPrice',
    align: 'center',
    width: 160
  },
  {
    label: t('合计金额（清算后）'),
    prop: 'allIncludeProductTotalPrice',
    slotName: 'allIncludeProductTotalPrice',
    align: 'center',
    width: 160
  },
  {
    label: t('是否有异常联络'),
    prop: 'abnormalSlot',
    align: 'center',
    slotName: 'abnormalSlot',
    width: 130
  }
  // {
  //   label: t('费用明细'),
  //   prop: 'feeDetail',
  //   align: 'center',
  //   slotName: 'feeDetail'
  // }
]
export const tableConfig = {
  showSelection: true,
  showHandler: true,
  showExpand: true,
  canRowClick: true,
  rowKey: 'platformOrderId',
  setHeight: true,
  height: 600
}

export const childConfig = {
  showHandler: false,
  showExpand: true,
  canRowClick: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList'
  // handlerConfig: { label: '', minWidth: 200, fixed: true }
}

export const BDialogChildColumns: any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'orderId',
    slotName: 'orderId'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 280,
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'shoppingStyle',
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'shoppingSku',
    align: 'center'
  },
  {
    label: t('商品状态'),
    prop: 'shoppingStats',
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('下单数量'),
    prop: 'orderNum',
    align: 'center'
  }
]

export const BDialogTableConfig = {
  showExpand: true,
  rowKey: 'deliveryTaskCode'
}

export const childApiConfig = {
  listPath: 'data'
}

/** ------------------------------------------ */

export const orderSourceEnum: any = {
  1: t('THE CKB'),
  2: t('Base'),
  3: t('Shopify'),
  4: t('Stores'),
  6: t('表格下单'),
  8: t('cafe24'),
  9: t('自建独立站'),
  11: t('TIKTOK')
}

export const platformOrderTypeEnum: any = {
  1: t('直发订单'),
  2: t('囤货订单'),
  4: isD2C() ? t('直发订单(一口价)') : t('囤货订单(一口价)')
  // 3: t('部分转库存')
}

export const preferDeliverFlagEnum: any = {
  0: t('不可优先发货'),
  1: t('可优先发货')
}

export const channelEnum: any = {
  1: t('市场购'),
  2: t('透明购'),
  5: t('线下')
}
export const combinationStatusDict: any = {
  1: t('未组合'),
  2: t('组合中'),
  3: t('组合完成'),
  4: t('取消组合')
}

export const settlementStatus: any = {
  1: t('未结算'),
  2: t('结算中'),
  3: t('已结算'),
  4: t('结算失败'),
  5: t('部分清算')
}

export const settlementStatus2: any = {
  1: t('未结算'),
  // 2: t('结算中'),
  3: t('已结算')
  // 4: t('结算失败')
}

export const settlementStatus3: any = {
  1: t('未结算'),
  5: t('部分清算'),
  3: t('已结算')
  // 4: t('结算失败')
}
/** 商品行上的 */
export const productSettlementStatus: any = {
  1: t('未结算'),
  // 2: t('结算中'),
  3: t('已结算')
  // 4: t('结算失败')
}

// 1 未结算
// 3 已经结算

// 1 未结算
// 3 已经结算
